import React from 'react';

/**
 * Standard dropdown arrow icon for use with all select controls.
 * Usage: Place <DropdownArrow /> inside a wrapper next to <Form.Select> or <select>.
 */
const DropdownArrow: React.FC<{ className?: string }> = ({ className = '' }) => (
  <span className={`app-dropdown-arrow-shell ${className}`} aria-hidden="true">
    <svg viewBox="0 0 20 20" width="18" height="18" focusable="false" aria-hidden="true">
      <path d="M5.5 8l4.5 4 4.5-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </span>
);

export default DropdownArrow;
